export const DEFAULT_LOCALE = "en";

export const DEFAULT_PARTNER = "pandas";
